import * as Yup from "yup";
import i18n from "../i18n";

export const MeetingRoomsSchema = Yup.object({
  meetingRoomNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Meeting Room (English) is required"
      : "مطلوب غرفة اجتماعات (باللغة الإنجليزية)"
  ),
  meetingRoomNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Meeting Room (Arabic) is required"
      : "مطلوب غرفة اجتماعات (عربية)"
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required." : "الموقع مطلوب."
  ),
  building: Yup.string().required(
    i18n.language === "en" ? "Building is required" : "مطلوب بناء"
  ),
  description: Yup.string().nullable(),
});
